import axios from 'axios';
import getApiUrl from 'src/utils/get-api-url';

const apiUrl = getApiUrl();

/**
 * Get filters for some collaborator's attributes.
 * 
 * @returns {Promise<Object>}
 */
export function list() {
    return axios.get(`${apiUrl}/deallocation/filters`);
} 
